import { useEffect, useState } from "react";
import {
  Airplane,
  ArrowToDownHeader,
  CheckMarkIcon,
  CopyIcon,
  HandKey,
  LightIcon,
  Logo,
  NotificationBingIconHeader,
  SwapIconHeader,
  UnVerified,
  UserBoxIcon,
  VerifyUserIcon,
} from "../../AssetComponents/Images";
import { PurpleButton } from "../../Components/Buttons/PurpleButton";
import { Popover } from "react-tiny-popover";
import { SelectionGroup,SelectionItem } from "../../Components/Selection/Selection";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setConnectModal } from "../../ReduxSlices/ModalSlice";
import { truncateWalletAddress } from "../../Components/functions/Functions";
import { BlackButton } from "../../Components/Buttons/BlackButton";
import CopyToClipboard from "react-copy-to-clipboard";
import { setDisconnect } from "../../ReduxSlices/AuthSlice";
import { Testnet, Mainnet } from "@nibiruchain/nibijs";
import { getProfileFromWallet } from "../../Components/functions/Functions";
import { setEthereum } from "../../ReduxSlices/AuthSlice";
import { ConnectButton, lightTheme, useActiveAccount } from "thirdweb/react";
import { createWallet } from "thirdweb/wallets";
import { thiredWebClient } from "../../Components/functions/Functions";
import keplrIcon from "../../assets/images/Keplr_icon_ver.1.3_2.svg"
import { ChartCandlestick, Landmark, Menu, X } from 'lucide-react';
import { useOnboarding } from "./OnBoarding1";

const metamaskIcon = "https://upload.wikimedia.org/wikipedia/commons/3/36/MetaMask_Fox.svg";

const getWalletIcon = (walletType) => {
  switch (walletType) {
    case "leap":
      return "https://assets.leapwallet.io/logos/leap-cosmos-logo.svg";
    case "keplr":
      return keplrIcon;
    case "metamask":
    case "MetaMask":
      return metamaskIcon;
    case "bybit":
    case "Bybit":
      return "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqB80t8g90uzbolr1TPrZ6_T30jzCnvNok6g&s";
    default:
      return "";
  }
};

const safeFormatDate = (timeUTC, diff, options) => {
  if (!timeUTC || isNaN(new Date(timeUTC).getTime())) {
    return "N/A"; // Fallback
  }
  return new Intl.DateTimeFormat("en-US", options).format(
    (Math.round(new Date(timeUTC).getTime() / 1000) - diff) * 1000
  );
};

export const Header = () => {
  const [showDashboardMenu, setShowDashboardMenu] = useState(false);
  const [showTradeMenu, setShowTradeMenu] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [showConnect, setShowConnect] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false); // Add mobile menu state
  
  const isConnected = useSelector((state) => state.auth.isConnected);
  const account = useSelector((state) => state.auth.account);
  const wallet = useSelector((state) => state.auth.wallet);
  const diff = useSelector((state) => state.time.diffToUTC);
  const ethereum = useSelector((state) => state.auth.ethereum);
  const profile = useSelector((state) => state.auth.profile);
  const nfts = useSelector((state) => state.nft.nfts);
  const notificationContent = useSelector((state) => state.notification.items);
  const navigate = useNavigate();
  const [copied, setCopied] = useState(false);
  const location = useLocation();
  const dispatch = useDispatch();
  const [current, setCurrent] = useState();
  const [maskString, setMaskString] = useState("shadow-md rounded-[10px]");
  const mainnet = Mainnet();
  const [profiles, setProfiles] = useState({});

  const tryConnect = () => {
    if (current === 4) {
      if (!ethereum) dispatch(setConnectModal(true));
      else {
        dispatch(setEthereum(null));
      }
    } else dispatch(setConnectModal(true));
  };

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const initiateCopy = async () => {
    await delay(2000);
    setCopied(false);
  };

  const handleDisconnect = async () => {
    dispatch(setDisconnect());
    const r = await window.leap.disconnect(mainnet.chainId);
    console.log(r);
  };

  useEffect(() => {
    if (isConnected) setShowConnect(false);
  }, [isConnected]);

  useEffect(() => {
    if (copied) initiateCopy();
  }, [copied]);

  useEffect(() => {
    setMaskString("shadow-md rounded-[10px]");
    switch (location.pathname.split("/")[1]) {
      case "rent":
        setCurrent(0);
        break;
      case "perps":
        setCurrent(2);
        break;
      case "yieldestate":
        setCurrent(3);
        break;
      case "earn":
        setCurrent(4);
        break;
      case "dashboard":
        setCurrent(5);
        break;

      default:
        setCurrent(-1);
        setMaskString("");
        break;
    }
  }, [location]);

  const getProfile = async (address, profiles) => {
    if (profiles[address] || profiles[address] === false) return;
    const profile = await getProfileFromWallet(address);
    profiles[address] = profile;
  };

  const getProfiles = async () => {
    let tempProfiles = {};
    for (let i = 0; i < notificationContent.length; i++) {
      if (notificationContent[i].type === "message") {
        getProfile(notificationContent[i].data.message.sender, tempProfiles);
      } else {
        getProfile(notificationContent[i].data.sender, tempProfiles);
      }
    }
    setProfiles(tempProfiles);
  };

  useEffect(() => {
    getProfiles();
  }, [notificationContent]);
  
  const activeAccount = useActiveAccount();

  useEffect(() => {
    if (activeAccount?.address) {
      dispatch(setEthereum(activeAccount.address));
    } else {
      dispatch(setEthereum(null));
    }
  }, [activeAccount]);

  const parseAction = (action) => {
    switch (action) {
      case "finalize_short_term_rental":
        return (
          <div className="flex items-center">
            <div className="text-[#38A569]">Completed</div>
          </div>
        );
      case "set_reservation_for_short_term":
        return (
          <div className="flex items-center">
            <div className="text-[#38A569]">Reserved</div>
          </div>
        );
      case "cancel_reservation_for_shortterm":
        return (
          <div className="flex items-center">
            <div className="text-[#DB1F22]">Canceled</div>
          </div>
        );
      case "cancel_rental_for_shortterm":
        return (
          <div className="flex items-center">
            <div className="text-[#DB1F22]">Canceled</div>
          </div>
        );
      case "reject_reservation_for_shortterm":
        return (
          <div className="flex items-center">
            <div className="text-[#DB1F22]">Rejected</div>
          </div>
        );
      default:
        break;
    }
  };

  // Add this helper function to determine the correct navigation path for notifications
  const getNotificationPath = (item, account, nfts) => {
    if (item.type === "message") {
      const isOwner = nfts[item.data.nftId]?.access.owner === account;
      return isOwner 
        ? `/dashboard/host/inbox?chat=${item.data.id}` 
        : `/dashboard/traveler/inbox?chat=${item.data.id}`;
    }
    
    if (item.type === "event") {
      // Ensure token_id is valid
      const tokenId = item.data.token_id;
      if (!tokenId || tokenId === 'undefined' || tokenId === 'null') {
        return "/dashboard";
      }
      
      const nft = nfts[tokenId];
      const isOwner = nft?.access?.owner === account;
      
      // Helper function to find renting_period from NFT data
      const getRentingPeriod = () => {
        // First, try to get from notification data directly
        if (item.data.renting_period && Array.isArray(item.data.renting_period) && item.data.renting_period.length === 2) {
          return item.data.renting_period;
        }
        
        // Otherwise, try to find from NFT rentals array
        if (nft?.rentals?.rentals && Array.isArray(nft.rentals.rentals)) {
          const action = item.data.action;
          const sender = item.data.sender;
          
          // For cancel/reject actions, find the cancelled/rejected reservation
          if (action === "cancel_reservation_for_shortterm" || 
              action === "cancel_rental_for_shortterm" || 
              action === "reject_reservation_for_shortterm") {
            // Find the most recent cancelled/rejected reservation
            for (let i = nft.rentals.rentals.length - 1; i >= 0; i--) {
              const reservation = nft.rentals.rentals[i];
              if (reservation.renting_period && 
                  Array.isArray(reservation.renting_period) && 
                  reservation.renting_period.length === 2 &&
                  (reservation.cancelled || (!reservation.approved && action === "reject_reservation_for_shortterm"))) {
                return reservation.renting_period;
              }
            }
          }
          
          // For finalize action, find the most recent finalized (approved) reservation
          if (action === "finalize_short_term_rental") {
            for (let i = nft.rentals.rentals.length - 1; i >= 0; i--) {
              const reservation = nft.rentals.rentals[i];
              if (reservation.renting_period && 
                  Array.isArray(reservation.renting_period) && 
                  reservation.renting_period.length === 2 &&
                  reservation.approved && 
                  !reservation.cancelled) {
                return reservation.renting_period;
              }
            }
          }
          
          // For set_reservation, find the most recent reservation that matches the sender
          if (action === "set_reservation_for_short_term") {
            for (let i = nft.rentals.rentals.length - 1; i >= 0; i--) {
              const reservation = nft.rentals.rentals[i];
              if (reservation.renting_period && 
                  Array.isArray(reservation.renting_period) && 
                  reservation.renting_period.length === 2 &&
                  reservation.address === sender) {
                return reservation.renting_period;
              }
            }
          }
          
          // Fallback: get the most recent reservation with valid renting_period
          for (let i = nft.rentals.rentals.length - 1; i >= 0; i--) {
            const reservation = nft.rentals.rentals[i];
            if (reservation.renting_period && 
                Array.isArray(reservation.renting_period) && 
                reservation.renting_period.length === 2) {
              return reservation.renting_period;
            }
          }
        }
        
        return null;
      };
      
      switch (item.data.action) {
        case "set_reservation_for_short_term":
        case "finalize_short_term_rental":
        case "cancel_reservation_for_shortterm":
        case "cancel_rental_for_shortterm":
        case "reject_reservation_for_shortterm":
          const rentingPeriod = getRentingPeriod();
          if (rentingPeriod && rentingPeriod.length === 2) {
            const from = rentingPeriod[0];
            const to = rentingPeriod[1];
            return isOwner 
              ? `/dashboard/host/reservations/${tokenId}?from=${from}&to=${to}` 
              : `/dashboard/traveler/trips/${tokenId}?from=${from}&to=${to}`;
          }
          
          // Fallback to reservations with token_id if we can't find renting_period
          return isOwner 
            ? `/dashboard/host/reservations/${tokenId}` 
            : `/dashboard/traveler/trips/${tokenId}`;
        
        default:
          // For any other event with a token_id, redirect to reservations
          return isOwner 
            ? `/dashboard/host/reservations/${tokenId}` 
            : `/dashboard/traveler/trips/${tokenId}`;
      }
    }
    
    return "/dashboard";
  };

  const { isOnboarding, currentStep } = useOnboarding();

  // Don't render header on onboarding pages
  if (location.pathname === '/rent/onboarding' || location.pathname === '/rent/onboarding/Completion' || location.pathname === '/rent/onboarding/privacy' || location.pathname === '/rent/onboarding/terms' || location.pathname === '/rent/onboarding/about' ) {
    return null;
  }

  const handleMobileNavigation = (path, currentValue) => {
    navigate(path);
    setCurrent(currentValue);
    setShowMobileMenu(false);
  };

  return (
    <>
      <div className={isOnboarding && currentStep === 7 ? "relative z-50" : ""}>
        {current !== 4 ? (
          <>
            <div className="bg-white flex w-full items-center justify-between py-[14px] px-[16px] md:grid md:grid-cols-3 md:justify-items-center">
              {/* Logo */}
              <Logo
                onClick={() => {
                  navigate("/");
                }}
                className="justify-self-start cursor-pointer"
              />

              {/* Desktop Navigation */}
              <div className="hidden md:block">
                <SelectionGroup
                  className="px-[6px] py-[4px] gap-[8px] flex items-center rounded-[14px] bg-[#f6f6f6] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
                  defaultItem={current}
                  // SelectedItemMask={maskString}
                >
                  <SelectionItem
                    SelectedItem={
                      <div className="cursor-pointer bg-white rounded-[10px] w-[120px] flex justify-center gap-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                        <div className="text-black font-semibold">Rent</div>
                        <LightIcon />
                      </div>
                    }
                    UnselectedItem={
                      <div
                        onClick={() => {
                          navigate("/rent/all");
                          setCurrent(0);
                        }}
                        className="cursor-pointer hover:bg-white rounded-[10px] w-[120px] flex justify-center"
                      >
                        <div className="text-[#959595]">Rent</div>
                      </div>
                    }
                  />
                  <SelectionItem
                    disabled
                    UnselectedItem={
                      <div
                        className="cursor-pointer hover:bg-[#ffffff] rounded-[10px] w-[120px] flex justify-center"
                        data-tooltip-id="my-tooltip"
                      >
                        <div className="text-[#959595]">Buy</div>
                      </div>
                    }
                  />

                  <SelectionItem
                    disabled
                    UnselectedItem={
                      <Popover
                        isOpen={showTradeMenu}
                        positions={"bottom"}
                        onClickOutside={() => setShowTradeMenu(false)}
                        content={
                          <div
                            onClick={() => {
                              setShowTradeMenu(false);
                              setCurrent(2);
                            }}
                            className="mt-[10px] bg-white rounded-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
                          >
                            <div
                              onClick={() => navigate("/perps/markets/realestate")}
                              className="cursor-pointer hover:bg-[#f5f5f5] rounded-t-[10px] p-[8px] gap-[8px] flex items-center w-full"
                            >
                              <ChartCandlestick size={16} className="text-[#666666]"/>
                              <div className="text-[#666666]">Markets</div>
                            </div>
                            <div
                              onClick={() => navigate("/perps/vaults")}
                              className="cursor-pointer hover:bg-[#f5f5f5] rounded-b-[10px] p-[8px] gap-[8px] flex items-center w-full"
                            >
                              <Landmark size={16} className="text-[#666666]"/>
                              <div className="text-[#666666]">Vaults</div>
                            </div>
                          </div>
                        }
                      >
                        <div
                          className="cursor-pointer hover:bg-white rounded-[10px] w-[120px] flex justify-center gap-[4px]"
                          onClick={() => setShowTradeMenu(true)}
                        >
                          <div className="text-[#959595]">Trade</div>
                          <ArrowToDownHeader />
                        </div>
                      </Popover>
                    }
                    SelectedItem={
                      <Popover
                        isOpen={showTradeMenu}
                        positions={"bottom"}
                        onClickOutside={() => setShowTradeMenu(false)}
                        content={
                          <div
                            onClick={() => {
                              setShowTradeMenu(false);
                              setCurrent(2);
                            }}
                            className="mt-[10px] bg-white rounded-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
                          >
                            <div
                              onClick={() => navigate("/perps/markets/realestate")}
                              className="cursor-pointer hover:bg-[#f5f5f5] rounded-t-[10px] p-[8px] gap-[8px] flex items-center w-full"
                            >
                              <ChartCandlestick size={16} className="text-[#666666]"/>
                              <div className="text-[#666666]">Markets</div>
                            </div>
                            <div
                              onClick={() => navigate("/perps/vaults")}
                              className="cursor-pointer hover:bg-[#f5f5f5] rounded-b-[10px] p-[8px] gap-[8px] flex items-center w-full"
                            >
                              <Landmark size={16} className="text-[#666666]"/>
                              <div className="text-[#666666]">Vaults</div>
                            </div>
                          </div>
                        }
                      >
                        <div
                          onClick={() => setShowTradeMenu(true)}
                          className="cursor-pointer bg-white rounded-[10px] w-[120px] flex justify-center gap-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
                        >
                          <div className="text-black font-semibold">Trade</div>
                          <LightIcon />
                        </div>
                      </Popover>
                    }
                  />

                  <SelectionItem
                    // disabled
                    SelectedItem={
                      <div
                        // data-tooltip-id="my-tooltip"
                        className="cursor-pointer bg-white rounded-[10px] w-[120px] flex justify-center gap-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
                      >
                        <div className="text-black font-semibold">YieldEstate</div>
                        <LightIcon />
                      </div>
                    }
                    UnselectedItem={
                      <div
                        onClick={() => {
                          navigate("/yieldestate");
                          setCurrent(3);
                        }}
                        // data-tooltip-id="my-tooltip"
                        className="cursor-pointer hover:bg-white rounded-[10px] w-[120px] flex justify-center"
                      >
                        <div className="text-[#959595]">YieldEstate</div>
                      </div>
                    }
                  />
                  <SelectionItem
                    disabled
                    UnselectedItem={
                      <Popover
                        isOpen={showDashboardMenu}
                        positions={"bottom"}
                        onClickOutside={() => setShowDashboardMenu(false)}
                        content={
                          <div
                            onClick={() => {
                              setShowDashboardMenu(false);
                              setCurrent(5);
                            }}
                            className="mt-[10px] bg-white rounded-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
                          >
                            <div
                              onClick={() => navigate("/dashboard/host/dashboard")}
                              className="cursor-pointer hover:bg-[#f5f5f5] rounded-t-[10px] p-[8px] gap-[8px] flex items-center w-full"
                            >
                              <HandKey />
                              <div className="text-[#666666]">Host mode</div>
                            </div>
                            <div
                              onClick={() =>
                                navigate("/dashboard/traveler/dashboard")
                              }
                              className="cursor-pointer hover:bg-[#f5f5f5] rounded-b-[10px] p-[8px] gap-[8px] flex items-center w-max"
                            >
                              <Airplane />
                              <div className="text-[#666666]">Traveler mode</div>
                            </div>
                          </div>
                        }
                      >
                        <div
                          className="cursor-pointer hover:bg-white rounded-[10px] w-[120px] flex justify-center gap-[4px]"
                          onClick={() => setShowDashboardMenu(true)}
                        >
                          <div className="text-black font-semibold">Dashboard</div>
                          <ArrowToDownHeader />
                        </div>
                      </Popover>
                    }
                    SelectedItem={
                      <Popover
                        isOpen={showDashboardMenu}
                        positions={"bottom"}
                        onClickOutside={() => setShowDashboardMenu(false)}
                        content={
                          <div
                            onClick={() => {
                              setShowDashboardMenu(false);
                              setCurrent(5);
                            }}
                            className="mt-[10px] bg-white rounded-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
                          >
                            <div
                              onClick={() => navigate("/dashboard/host/dashboard")}
                              className="cursor-pointer hover:bg-[#f5f5f5] rounded-t-[10px] p-[8px] gap-[8px] flex items-center w-full"
                            >
                              <HandKey />
                              <div className="text-[#666666]">Host mode</div>
                            </div>
                            <div
                              onClick={() =>
                                navigate("/dashboard/traveler/dashboard")
                              }
                              className="cursor-pointer hover:bg-[#f5f5f5] rounded-b-[10px] p-[8px] gap-[8px] flex items-center w-max"
                            >
                              <Airplane />
                              <div className="text-black font-semibold">Traveler mode</div>
                            </div>
                          </div>
                        }
                      >
                        <div
                          onClick={() => setShowDashboardMenu(true)}
                          className="cursor-pointer bg-white rounded-[10px] w-[120px] flex justify-center gap-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
                        >
                          <div className="text-black font-semibold">Dashboard</div>
                          <LightIcon />
                        </div>
                      </Popover>
                    }
                  />
                </SelectionGroup>
              </div>
              <div className="flex items-center justify-self-end">
                {/* Desktop Icons */}
                <div
                  data-tooltip-id="my-tooltip"
                  className="hidden md:block mr-[20px] hover:bg-[#f6f6f6] hover:translate-y-[-4px] cursor-pointer bg-white shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)] p-[10px] rounded-full"
                >
                  <SwapIconHeader />
                </div>

                {/* Notification Icon */}
                <Popover
                  isOpen={showNotification}
                  positions={"bottom"}
                  onClickOutside={() => setShowNotification(false)}
                  containerStyle={{ zIndex: 9999 }}
                  content={
                    <div className="p-[10px] bg-white mt-[10px] w-[300px] h-[500px] rounded-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                      <div className="flex items-center gap-2 mb-2">
                        <svg
                          className="w-[20px] h-[20px]"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M8 14V14C4.686 14 2 11.314 2 8V8C2 4.686 4.686 2 8 2V2C11.314 2 14 4.686 14 8V8C14 11.314 11.314 14 8 14Z"
                            stroke="#505050"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M7.9987 11.3333V8H7.33203"
                            stroke="#505050"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M7.83267 5.33333C7.74067 5.33333 7.666 5.408 7.66667 5.5C7.66667 5.592 7.74134 5.66667 7.83334 5.66667C7.92534 5.66667 8 5.592 8 5.5C8 5.408 7.92534 5.33333 7.83267 5.33333"
                            stroke="#505050"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <div className="font-semibold text-[18px]">
                          Notifications
                        </div>
                      </div>

                      {notificationContent.length > 0 ? (
                        <div className="space-y-[4px] h-[90%] w-full overflow-auto scrollbarwidth">
                          {notificationContent
                            .slice()
                            .reverse()
                            .map((item, i) => {
                              if (item.type === "event")
                                return (
                                  <div
                                    key={i}
                                    onClick={() => {
                                      setShowNotification(false);
                                      const path = getNotificationPath(item, account, nfts);
                                      navigate(path);
                                    }}
                                    className="hover:bg-[#f0f0f0] rounded-[4px] cursor-pointer p-[6px] w-full flex items-center justify-between"
                                  >
                                    {profiles[item.data.sender]?.Avatar ? (
                                      <img
                                        alt=""
                                        src={profiles[item.data.sender]?.Avatar}
                                        className="w-[44px] h-[44px] rounded-full shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
                                      />
                                    ) : (
                                      <div className="w-[44px] h-[44px] flex bg-[#f0f0f0] rounded-full">
                                        <UserBoxIcon className="m-auto" />
                                      </div>
                                    )}

                                    <div>
                                      <div>
                                        {profiles[item.data.sender]?.Name
                                          ? profiles[
                                              item.data.sender
                                            ]?.Name?.replace("/", " ")
                                          : truncateWalletAddress(item.data.sender)}
                                      </div>
                                      <div className="flex gap-2 w-[150px] truncate">
                                        <span className="font-semibold">
                                          {parseAction(item.data.action)}
                                        </span>
                                        <span className="truncate">
                                          {
                                            nfts[item.data.token_id]?.metaData
                                              .buildingName
                                          }
                                        </span>
                                      </div>
                                    </div>

                                    <div>
                                      <div className="text-[12px] text-end">
                                        {safeFormatDate(item.data.timeUTC, diff, {
                                          day: "numeric",
                                          month: "short",
                                        })}
                                      </div>
                                      <div className="text-[12px] text-end">
                                        {safeFormatDate(item.data.timeUTC, diff, {
                                          hour: "numeric",
                                          minute: "2-digit",
                                          hour12: true,
                                        })}
                                      </div>
                                    </div>
                                  </div>
                                );
                              else
                                return (
                                  <div
                                    onClick={() => {
                                      setShowNotification(false);
                                      const path = getNotificationPath(item, account, nfts);
                                      navigate(path);
                                    }}
                                    className="hover:bg-[#f0f0f0] rounded-[4px] cursor-pointer p-[6px] w-full flex items-center justify-between"
                                  >
                                    {profiles[item.data.message.sender]?.Avatar ? (
                                      <img
                                        alt=""
                                        src={
                                          profiles[item.data.message.sender]?.Avatar
                                        }
                                        className="w-[44px] h-[44px] rounded-full shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
                                      />
                                    ) : (
                                      <div className="w-[44px] h-[44px] flex bg-[#f0f0f0] rounded-full">
                                        <UserBoxIcon className="m-auto" />
                                      </div>
                                    )}

                                    <div>
                                      <div>
                                        {profiles[item.data.message.sender]?.Name
                                          ? profiles[
                                              item.data.message.sender
                                            ]?.Name?.replace("/", " ")
                                          : truncateWalletAddress(
                                              item.data.message.sender
                                            )}
                                      </div>

                                      <div className="flex gap-2 w-[150px] truncate">
                                        <span className="truncate">
                                          Sent new message
                                        </span>
                                      </div>
                                    </div>

                                    <div>
                                      <div className="text-[12px] text-end">
                                        {safeFormatDate(
                                          item.data.message.generatedTime,
                                          diff,
                                          {
                                            day: "numeric",
                                            month: "short",
                                          }
                                        )}
                                      </div>
                                      <div className="text-[12px] text-end">
                                        {safeFormatDate(
                                          item.data.message.generatedTime,
                                          diff,
                                          {
                                            hour: "numeric",
                                            minute: "2-digit",
                                            hour12: true,
                                          }
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                );
                            })}
                        </div>
                      ) : (
                        <div className="w-full h-[80%] flex">
                          <div className="m-auto">No contents</div>
                        </div>
                      )}
                    </div>
                  }
                >
                  <div
                    onClick={() => setShowNotification(true)}
                    className="mr-[40px] hover:bg-[#f6f6f6] hover:translate-y-[-4px] relative cursor-pointer bg-white shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)] p-[10px] rounded-full"
                  >
                    {notificationContent.length ? (
                      <div className="absolute top-0 right-[6px] bg-red-500 rounded-full w-[10px] h-[10px]"></div>
                    ) : (
                      <></>
                    )}
                    <NotificationBingIconHeader />
                  </div>
                </Popover>

                {/* Mobile Menu Toggle - Highlight during step 8 */}
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowMobileMenu(!showMobileMenu);
                  }}
                  className={`md:hidden cursor-pointer bg-white shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)] p-[10px] rounded-full hover:bg-[#f6f6f6] ${
                    isOnboarding && currentStep === 8 
                      ? 'onboarding-highlight border-2 border-purple-500 ring-4 ring-purple-300 animate-pulse' 
                      : ''
                  }`}
                >
                  {showMobileMenu ? <X size={20} /> : <Menu size={20} />}
                </div>

                {/* Desktop Connect Wallet - Highlight during step 8 */}
                <div className="hidden md:block">
                  <Popover
                    isOpen={showConnect && isConnected}
                    onClickOutside={() => setShowConnect(false)}
                    positions={"bottom"}
                    content={
                      <div className="mr-[16px] flex flex-col items-center p-[20px] mt-[10px] bg-white rounded-[10px] w-[300px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                        <div className="flex items-center">
                          <button
                            type="button"
                            onClick={() => {
                              setShowConnect(false);
                              // Default to traveler profile view from onboarding header
                              navigate("/dashboard/profile?mode=traveler");
                            }}
                            className="cursor-pointer rounded-full p-0 border-0 bg-transparent hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-[#38A569] focus:ring-offset-1"
                            aria-label="Go to profile"
                          >
                            {profile?.Avatar ? (
                              <img
                                alt="Profile"
                                src={profile?.Avatar}
                                className="w-[100px] rounded-full shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
                              />
                            ) : (
                              <VerifyUserIcon className="w-[120px]" />
                            )}
                          </button>

                          <svg
                            className="w-[60px] h-[40px]"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M13.5 16L17.5 12L13.5 8"
                              stroke="#38A569"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M6.5 17L11.5 12L6.5 7"
                              stroke="#38A569"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <img
                            alt=""
                            src={getWalletIcon(wallet)}
                            className="w-[80px] h-[80px]"
                          />
                        </div>
                        <CopyToClipboard
                          text={account}
                          onCopy={() => setCopied(true)}
                        >
                          <div className="w-full mt-3">
                            <PurpleButton
                              text={
                                <div className="flex items-center gap-3 justify-center">
                                  <span>
                                    {truncateWalletAddress(account)?.toUpperCase()}
                                  </span>
                                  {copied && <CheckMarkIcon />}
                                </div>
                              }
                            />
                          </div>
                        </CopyToClipboard>
                        <div className="w-full mt-3">
                          <BlackButton text="Disconnect" onClick={handleDisconnect} />
                        </div>
                      </div>
                    }
                  >
                    <div
                      className="w-max h-max"
                      onClick={() => {
                        if (isConnected) setShowConnect(!showConnect);
                        else tryConnect();
                      }}
                    >
                      <div className={
                        isOnboarding && currentStep === 8 
                          ? 'onboarding-highlight border-2 border-purple-500 ring-4 ring-purple-300 animate-pulse rounded-lg' 
                          : ''
                      }>
                        <PurpleButton
                          text={
                            isConnected
                              ? truncateWalletAddress(account)
                              : "Connect Wallet"
                          }
                        />
                      </div>
                    </div>
                  </Popover>
                </div>
              </div>
            </div>

            {/* MOBILE MENU OVERLAY - Copy from Header.js */}
            {showMobileMenu && (
              <div className="md:hidden absolute top-full left-0 w-full bg-white shadow-lg z-50 border-t">
                <div className="p-4 space-y-4">
                  {/* Mobile Navigation Links */}
                  <div
                    onClick={() => handleMobileNavigation("/rent/short", 0)}
                    className={`cursor-pointer p-3 rounded-lg hover:bg-[#f6f6f6] ${current === 0 ? 'bg-[#f0f0f0] font-semibold' : ''}`}
                  >
                    <div className="text-[#505050]">Rent</div>
                  </div>

                  {/* Dashboard Submenu */}
                  <div className="border-l-2 border-[#f0f0f0] pl-4">
                    <div className="text-[#666666] font-medium mb-2">Dashboard</div>
                    <div
                      onClick={() => handleMobileNavigation("/dashboard/host/dashboard", 5)}
                      className="cursor-pointer p-2 rounded-lg hover:bg-[#f6f6f6] flex items-center gap-2"
                    >
                      <HandKey />
                      <div className="text-[#666666]">Host mode</div>
                    </div>
                    <div
                      onClick={() => handleMobileNavigation("/dashboard/traveler/dashboard", 5)}
                      className="cursor-pointer p-2 rounded-lg hover:bg-[#f6f6f6] flex items-center gap-2"
                    >
                      <Airplane />
                      <div className="text-[#666666]">Traveler mode</div>
                    </div>
                  </div>

                  {/* Mobile Connect Wallet - Highlight during step 8 */}
                  <div className="border-t pt-4">
                    <div
                      onClick={() => {
                        if (isConnected) setShowConnect(!showConnect);
                        else tryConnect();
                        setShowMobileMenu(false);
                      }}
                      className="w-full"
                    >
                      <div className={
                        isOnboarding && currentStep === 8 
                          ? 'onboarding-highlight border-2 border-purple-500 ring-4 ring-purple-300 animate-pulse rounded-lg' 
                          : ''
                      }>
                        <PurpleButton
                          text={
                            isConnected
                              ? truncateWalletAddress(account)
                              : "Connect Wallet"
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        ) : (
          <div className="fixed w-full bg-white">
            <div className="flex items-center justify-between py-[14px] px-[16px]">
              <Logo className="justify-self-start" />
              <button
                className="md:hidden p-2 rounded-md bg-gray-200"
                onClick={() => setShowMobileMenu(!showMobileMenu)}
              >
                <div className="flex flex-col space-y-1">
                  <span className="block w-6 h-0.5 bg-black"></span>
                  <span className="block w-6 h-0.5 bg-black"></span>
                  <span className="block w-6 h-0.5 bg-black"></span>
                </div>
              </button>
              {showMobileMenu && (
                <div className="absolute top-[60px] right-0 bg-white shadow-md rounded-lg p-4 w-[200px]">
                  <ul className="space-y-2">
                    <li className="cursor-pointer hover:bg-gray-100 p-2 rounded-md">Rent</li>
                    <li className="cursor-pointer hover:bg-gray-100 p-2 rounded-md">Buy</li>
                    <li className="cursor-pointer hover:bg-gray-100 p-2 rounded-md">Trade</li>
                    <li className="cursor-pointer hover:bg-gray-100 p-2 rounded-md">Dashboard</li>
                  </ul>
                </div>
              )}
              <ConnectButton
                theme="light"
                connectButton={{
                  label: "Connect wallet",
                  className:
                    "thirdwebbutton hover:shadow-[-1px_6px_10px_0_rgba(93,0,207,0.5)] hover:translate-y-[-3px]",
                }}
                detailsButton={{
                  render() {
                    return (
                      <PurpleButton text={truncateWalletAddress(ethereum)} />
                    );
                  },
                }}
                client={thiredWebClient}
                wallets={[createWallet("com.bybit"), createWallet("io.metamask")]}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
};